<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-button :to="{name: isUpdate ? 'app-list': 'service-list', params: {serviceCode: $route.params.serviceCode}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
        <strong>{{ caption }}</strong> 实例
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="服务名" label-for="service_code">
          <b-form-input id="service_code" v-model="data.service_code" disabled required />
        </b-form-group>
        <b-form-group label="实例代号" label-for="code">
          <b-form-input id="code" type="text" v-model="data.code" :disabled="isUpdate" required />
        </b-form-group>
        <b-form-group label="产品" label-for="product_code">
          <b-form-select
            id="product_code"
            v-model="data.product_code"
            :options="products"
            text-field="name"
            value-field="code"
            :disabled="isUpdate"
            required
          />
        </b-form-group>
        <b-form-group label-for="tags" label="标签：">
          <el-select multiple filterable allow-create default-first-option class="mb-2" id="tags"
                     placeholder="选择或输入，按回车键确认" v-model="data.tags">
            <el-option v-for="tag in allTags" :key="tag.value" :label="tag.text" :value="tag.value" />
          </el-select>
        </b-form-group>
        <template v-if="!hasTemplate">
          <b-form-group>
            暂无描述模板，<router-link :to="{ name: 'template-edit' }">点击</router-link>前往配置
          </b-form-group>
        </template>
        <template v-else>
          <b-form-group label="实例信息" label-for="descs" label-class="font-weight-bold">
            <b-card>
              <confnode :useDefault="true" :items="data.descs" :userPerm="userPerm()" :strict="true" />
            </b-card>
          </b-form-group>
          <b-form-group v-if="!isUpdate" label="创建实例参数配置" label-for="create" label-class="font-weight-bold">
            <b-card>
              <confnode :useDefault="true" :items="data.create" :userPerm="userPerm()" :strict="true" />
            </b-card>
          </b-form-group>
          <b-form-group>
            <b-row class="mb-2">
              <b-col sm="2"><label class="font-weight-bold">实例配置</label></b-col>
              <b-col sm="8" />
              <b-col>
                <b-form-select id="confs_history" @change="changeConf" v-model="selectedConf" :options="confsHistory" />
              </b-col>
            </b-row>
            <b-card>
              <confnode v-if="isUpdate" :items.sync="data.confs" :userPerm="userPerm()" :strict="true" />
              <confnode v-else :useDefault="true" :items.sync="data.confs" :userPerm="userPerm()" :strict="true" />
            </b-card>
          </b-form-group>
          <b-form-group v-if="isUpdate && Object.keys(data.interfaces).length > 0" label="接口信息" label-class="font-weight-bold">
            <b-card>
              <AppTab v-if="tabShow" :items="data.interfaces" :notData="true" />
            </b-card>
          </b-form-group>
          <b-form-group v-if="isUpdate && Object.keys(data.stats).length > 0" label="统计接口" label-class="font-weight-bold">
            <AppTab v-if="tabShow" :items="data.stats" :notData="true" />
          </b-form-group>
          <b-form-group v-if="isUpdate && Object.keys(data.checks).length > 0" label="心跳检查" label-class="font-weight-bold">
            <AppTab v-if="tabShow" :items="data.checks" :notData="true" />
          </b-form-group>
        </template>
        <div slot="footer">
          <b-button type="submit" class="footer-btn" size="sm" variant="outline-primary"><i class="fa fa-cloud-upload" /> 提交</b-button>
          <b-button class="footer-btn back-btn" type="reset" size="sm" variant="outline-secondary"><i class="fa fa-remove" /> 返回</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import utils from '@/utils/utils'
import consts from '@/utils/consts'
import Confnode from '@/components/Confnode'
import ConfField from '@/components/Conffield'
import AppTab from '@/views/template/AppTab'

export default {
  name: 'app-update',
  mixins: [Error],
  components: {
    Confnode,
    ConfField,
    AppTab
  },
  data: () => {
    return {
      data: {
        service_code: '',
        product_code: '',
        code: '',
        descs: {},
        confs: {},
        confs_history: [],
        interfaces: {},
        stats: {},
        checks: {},
        preview: 1,
        tags: [],
        app_status: 'offline'
      },
      preview: 1,
      previewing: false,
      service: {},
      products: [],
      allTags: [],
      selectedConf: 0,
      appStatus: consts.APP_STATUS,
      createConfMethod: 0,
      serviceTemplate: {},
      hasTemplate: false,
      tabShow: true,
      descsStatic: null,
      confsStatic: null,
      interfacesStatic: null,
      statsStatic: null,
      checksStatic: null
    }
  },
  computed: {
    // eslint-disable-next-line
    isUpdate: function () { return !!this.$route.params.appCode },
    caption: function () { return this.isUpdate ? '更新' : '创建' },
    confsHistory: function () {
      let history = this.data.confs_history.map((obj, index) => {
        return {'value': index, 'text': 'V' + obj.version + ' ' + obj.create_time}
      })
      history.splice(0, 0, {value: null, text: '请选择版本', disabled: true})
      return history
    }
  },
  created () {
    this.$ajax.all([
      this.$ajax.get(api.getProductList()),
      this.$ajax.get(api.getServiceList()),
      this.$ajax.get(api.getAppTagList())
    ]).then(([productData, serviceData, tagData]) => {
      this.products.push({
        code: null, text: '请选择', disabled: true
      })
      productData.products.forEach((product) => {
        this.products.push({code: product.code, name: product.name})
      })
      tagData.tags.forEach((tag) => {
        this.allTags.push({value: tag, text: tag})
      })
    })
    this.getServiceTemplate()
  },
  methods: {
    fetchAppData () {
      this.$ajax.get(api.getAppDetail(this.$route.params.serviceCode, this.$route.params.appCode, this.$route.query.productCode)).then((appData) => {
        this.data = appData.app_info
        if (this.data.pre_confs && this.data.pre_confs.length > 0) {
          this.previewing = true
        }
        this.descsStatic = JSON.parse(JSON.stringify(appData.app_info.descs))
        this.confsStatic = JSON.parse(JSON.stringify(appData.app_info.confs))
        this.interfacesStatic = JSON.parse(JSON.stringify(appData.app_info.interfaces))
        this.statsStatic = JSON.parse(JSON.stringify(appData.app_info.stats))
        this.checksStatic = JSON.parse(JSON.stringify(appData.app_info.checks))

        this.data.descs.__Value__ = this.fixTemplate(this.serviceTemplate.descs.__Value__, this.data.descs.__Value__)
        this.data.confs.__Value__ = this.fixTemplate(this.serviceTemplate.confs.__Value__, this.data.confs.__Value__, true)
        if (Object.keys(this.data.interfaces).length === 0) {
          this.data.interfaces = JSON.parse(JSON.stringify(this.serviceTemplate.interfaces))
        } else {
          if (Object.keys(this.serviceTemplate.interfaces).length > 0) {
            this.data.interfaces = this.fixParam(this.serviceTemplate.interfaces, this.data.interfaces)
          } else {
            this.data.interfaces = JSON.parse(JSON.stringify(this.serviceTemplate.interfaces))
          }
        }
        if (Object.keys(this.data.stats).length === 0) {
          this.data.stats = JSON.parse(JSON.stringify(this.serviceTemplate.stats))
        } else {
          if (Object.keys(this.serviceTemplate.stats).length > 0) {
            this.data.stats = this.fixParam(this.serviceTemplate.stats, this.data.stats)
          } else {
            this.data.stats = JSON.parse(JSON.stringify(this.serviceTemplate.stats))
          }
        }
        if (Object.keys(this.data.checks).length === 0) {
          this.data.checks = JSON.parse(JSON.stringify(this.serviceTemplate.checks))
        } else {
          if (Object.keys(this.serviceTemplate.checks).length > 0) {
            this.data.checks = this.fixParam(this.serviceTemplate.checks, this.data.checks)
          } else {
            this.data.checks = JSON.parse(JSON.stringify(this.serviceTemplate.checks))
          }
        }
        this.updateAddress()
      }, (res) => {
        this.handleError(res)
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.data.preview = this.preview
      if (this.isUpdate) {
        this.data.saveHistory = !this.judgeModify(this.data.confs, this.confsStatic)
        this.$ajax.put(api.getAppDetail(
          this.$route.params.serviceCode, this.$route.params.appCode,
          this.$route.query.productCode
        ), this.data).then(
          (res) => {
            if (this.preview) {
              this.previewing = true
            } else {
              this.previewing = false
            }
            this.$message.info('更新成功')
            this.$router.push({name: 'app-list', param: {serviceCode: this.$route.params.serviceCode}})
          },
          (res) => {
            this.handleError(res)
          }
        )
      } else {
        this.data.saveHistory = true
        api.createData(this, api.getAppCreate(this.$route.params.serviceCode), this.data, 'app-list')
      }
    },
    submitOnline () {
      this.$ajax.post(
        api.getAppOnline(
          this.$route.params.serviceCode, this.$route.params.appCode,
          this.$route.query.productCode
        ), ''
      ).then((res) => {
        this.$message.info('操作成功')
        this.previewing = false
        this.fetchAppData()
      }, (res) => {
        this.handleError(res)
      })
    },
    revertPreview () {
      this.$ajax.post(
        api.getRevertPreview(
          this.$route.params.serviceCode, this.$route.params.appCode,
          this.$route.query.productCode
        ), ''
      ).then((res) => {
        this.$message.info('操作成功')
        this.previewing = false
        this.fetchAppData()
      }, (res) => {
        this.handleError(res)
      })
    },
    onReset (evt) {
      this.$router.push({name: this.isUpdate ? 'app-list' : 'service-list', params: {serviceCode: this.$route.params.serviceCode}})
    },
    userPerm () {
      if (!this.$store.getters.loginInfo.authority) {
        return null
      } else if (this.$store.getters.loginInfo.admin_type !== 'normal') {
        return '11111111111111111111111111111111'
      }
      let servicePerm = utils.findInArray(
        this.$store.getters.loginInfo.authority, this.data.service_code, 'authority', 'service_code'
      )
      if (servicePerm) {
        return utils.findInArray(
          servicePerm, this.data.product_code, 'mask', 'product_code'
        )
      } else {
        return null
      }
    },
    changeConf (value) {
      if (value !== null) {
        this.data.confs = utils.copyObject(this.data.confs_history[parseInt(value)].confs.confs)
      }
    },
    checkCreateMethod (val) {
      this.createConfMethod = val
    },
    getServiceTemplate () {
      this.$ajax.get(api.getTemplateByConsul(this.$route.params.serviceCode)).then((data) => {
        this.serviceTemplate = data['c_template_info']
        this.hasTemplate = !!(Object.keys(data['c_template_info']).length > 0 &&
          (
            Object.keys(data['c_template_info'].descs).length > 0 ||
            Object.keys(data['c_template_info'].create).length > 0 ||
            Object.keys(data['c_template_info'].confs).length > 0 ||
            Object.keys(data['c_template_info'].interfaces).length > 0 ||
            Object.keys(data['c_template_info'].stats).length > 0 ||
            Object.keys(data['c_template_info'].checks).length > 0
          ))
        if (this.isUpdate) {
          this.fetchAppData()
        } else {
          this.data.service_code = this.$route.params.serviceCode
          this.data.descs = this.serviceTemplate.descs
          this.data.create = this.serviceTemplate.create
          this.data.confs = this.serviceTemplate.confs
          this.data.interfaces = this.serviceTemplate.interfaces
          this.data.stats = this.serviceTemplate.stats
          this.data.checks = this.serviceTemplate.checks
        }
      }, (res) => {
        this.handleError(res)
      })
    },
    fixParam (template, appData) {
      let tmpData = {}
      for (let key in template) {
        if (appData.hasOwnProperty(key)) {
          if (template[key].hasOwnProperty('param')) {
            if (appData[key].hasOwnProperty('param')) {
              tmpData[key] = template[key]
              tmpData[key].param = appData[key].param
              tmpData[key].param.__Value__ = this.fixTemplate(template[key].param.__Value__, appData[key].param.__Value__)
            } else {
              tmpData[key] = template[key]
            }
          } else {
            tmpData[key] = this.fixParam(template[key], appData[key])
          }
        } else {
          tmpData[key] = template[key]
        }
      }
      return tmpData
    },
    fixTemplate (template, appData, judgeConfs = false) {
      let tmpData = {}
      if (Object.prototype.toString.call(template) === '[object Object]') {
        for (let key in template) {
          let val = template[key].__Value__
          if (appData.hasOwnProperty(key)) {
            if (template[key].__Value__.hasOwnProperty('__value__')) {
              val.__value__ = appData[key].__Value__.__value__
            } else {
              val = this.fixTemplate(template[key].__Value__, appData[key].__Value__, judgeConfs)
            }
          } else {
            if (judgeConfs) {
              this.selectedConf = null
            }
          }
          tmpData[key] = {
            __Index__: template[key].__Index__,
            __Tag__: template[key].__Tag__,
            __Value__: val
          }
          if (template[key].hasOwnProperty('__Key__')) {
            tmpData[key].__Key__ = template[key].__Key__
          }
        }
      } else if (Object.prototype.toString.call(template) === '[object Array]') {
        tmpData = []
        for (let idx in template) {
          let val = template[idx].__Value__
          if (appData[idx]) {
            if (template[idx].__Value__.hasOwnProperty('__value__')) {
              val.__value__ = appData[idx].__Value__.__value__
            } else {
              val = this.fixTemplate(template[idx].__Value__, appData[idx].__Value__, judgeConfs)
            }
          } else {
            if (judgeConfs) {
              this.selectedConf = null
            }
          }
          tmpData.push({
            __Index__: template[idx].__Index__,
            __Tag__: template[idx].__Tag__,
            __Value__: val
          })
          if (template[idx].hasOwnProperty('__Key__')) {
            tmpData[idx].__Key__ = template[idx].__Key__
          }
        }
      }
      return tmpData
    },
    fixAddress (appData, lastUrls = '') {
      if (appData.hasOwnProperty('param')) {
        appData.address = this.data.descs.__Value__.url.__Value__.__value__ + lastUrls
      } else {
        for (let key in appData) {
          let newUrl = key === '_appCode_' ? this.data.code : key === '_productCode_' ? this.data.product_code : key
          this.fixAddress(appData[key], [lastUrls, newUrl].join('/'))
        }
      }
    },
    updateAddress () {
      if (Object.keys(this.data.interfaces).length > 0) {
        this.fixAddress(this.data.interfaces)
      }
      if (Object.keys(this.data.stats).length > 0) {
        this.fixAddress(this.data.stats)
      }
      if (Object.keys(this.data.checks).length > 0) {
        this.fixAddress(this.data.checks)
      }
    },
    judgeModify (objectX, objectY) {
      if (objectX === objectY) {
        return true
      } else if ((typeof objectX === 'object' && objectX != null) && (typeof objectY === 'object' && objectY != null)) {
        if (Object.keys(objectX).length !== Object.keys(objectY).length) {
          return false
        }
        for (let prop in objectX) {
          if (objectY.hasOwnProperty(prop)) {
            if (!this.judgeModify(objectX[prop], objectY[prop])) {
              return false
            }
          } else {
            return false
          }
        }
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'data.descs.__Value__.url.__Value__.__value__': {
      handler: function (val, newVal) {
        this.tabShow = false
        this.updateAddress()
        this.$nextTick(() => {
          this.tabShow = true
        })
      }
    },
    'data.code': {
      handler: function (val, newVal) {
        this.tabShow = false
        this.updateAddress()
        this.$nextTick(() => {
          this.tabShow = true
        })
      }
    }
  }
}
</script>

<style>
  .footer-btn {
    margin-right: 5px;
  }
  .back-btn {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// AppUpdate.vue?49277bd0